<template>
<div class="chapter">
<div class="inner_page">
<p class="textcenter"><a id="ch00_fm04_copy"></a><a id="page_vi"></a>NEW YORK UNIVERSITY PRESS<br/>New York and London<br/><a class="nounder" href="http://www.nyupress.org" target="_blank">www.nyupress.org</a></p>
<p class="textcenter1">© 2003 by New York University<br/>All rights reserved.</p>
<p class="textcenter1">Library of Congress Cataloging-in-Publication Data<br/>McDaniel, Patricia (Patricia A.)</p>
<p class="textcenter">Shrinking violets and Caspar Milquetoasts :<br/>shyness, power, and intimacy in the United States, 1950–1995/<br/>Patricia McDaniel.</p>
<p class="textcenter">p. cm. — (The American social experience series)<br/>Includes bibliographical references and index.</p>
<p class="textcenter">ISBN 0–8147–5677–8 (alk. paper) — ISBN 0–8147–5678–6 (pbk. : alk. paper)<br/>1. Bashfulness—History. 2. Bashfulness—Social aspects—United States.</p>
<p class="textcenter">I. Title.  II. Series.</p>
<p class="textcenter">BF575.B3M34 2003</p>
<p class="textcenter">155.2’32—dc21         2003011890</p>
<p class="textcenter1">New York University Press books are printed on acid-free paper,<br/>and their binding materials are chosen for strength and durability.</p>
<p class="textcenter1">Manufactured in the United States of America</p>
<p class="textcenter1">10 9 8 7 6 5 4 3 2 1</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm04_copy.vue?6f8cb4ad